import { cloneDeep } from "lodash";

export const setActiveContentPictureChoiceOptionLabel = ({
  contents,
  activeContentId,
  data,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.options = content.options.map((option) => {
        if (option.id === data.id) {
          option.label = data.label;
        }

        return option;
      });
    }

    return cloneDeep(content);
  });
};

export default setActiveContentPictureChoiceOptionLabel;
